import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { getOneActionPlanActionsKey } from "./useGetOneActionPlanAction";
import { getOneActionPlanKey } from "../ActionPlan/useGetOneActionPlan";

type UnvalidatedUpsertReturn = {
    id: string;
};

type Options = {
    actionPlanID: string | undefined;
};
export const useUpsertActionPlanAction = (options: Options) => {
    const { actionPlanID } = options;
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: ActionPlanActionWrite) => {
            if (actionPlanID === undefined) {
                snackbar.forceClose();
                snackbar.setSnackbarProps({
                    type: "error",
                    message: "Missing an ActionPlanID. Please, contact your admin.",
                });
                return;
            }

            const header = {
                "Content-Type": "application/json",
            };
            const url = `/api/action_plan_actions`;
            const updateUrl = `/api/action_plans/${actionPlanID}/action`;

            const response =
                options.id === undefined ?
                    await loggedInApiCall.post<UnvalidatedUpsertReturn>(`${url}`, options, {
                        headers: header,
                    })
                :   await loggedInApiCall.put<UnvalidatedUpsertReturn>(`${updateUrl}/${options.id}`, options, {
                        headers: header,
                    });

            return response;
        },
        onSuccess: () => {
            queryClient.refetchQueries([getOneActionPlanActionsKey]);
            queryClient.refetchQueries([getOneActionPlanKey]);
        },
    });

    return query;
};

export type ActionPlanActionWrite = {
    id?: string;
    actionPlan?: IRI;
    actionId?: number;
    startSimulationSsqPost?: IRI;
    endSimulationSsqPost?: IRI;
    type?: string;
    userMessageTitle?: string;
    userMessageBody?: string;
};
